import { AssetDto, AssetVersionDto, AssetVideoTypeDataDto } from '@nusign/picflow-backend-types';
import { specialCaseFormats } from '../consts';
import { getExtension } from './get-extension';
import { isImagesBucketAsset } from './is-images-bucket-asset';

export const calcBaseUrlFromUuid = (cdn: string, uuid: string, ext: string) => {
  return `${cdn}/images/${uuid}/base/${uuid}.${ext}`;
};

export const calcBaseUrl = (cdn: string, asset: AssetDto, version: AssetVersionDto, watermark: boolean, page = 0) => {
  const ext = specialCaseFormats.includes(getExtension(version.asset_name)) ? 'webp' : 'jpg';

  if (isImagesBucketAsset(asset, version)) {
    const uuid = watermark ? version.watermark_uuid || version.uuid : version.uuid;
    return `${cdn}/images/${uuid}/base/${uuid}.${ext}`;
  }

  if (asset.type === 'video') {
    const data = version.data as AssetVideoTypeDataDto;
    const posterUrl = data.poster_url; // https://assets.dev.picflow.io/images/e593cb09-1392-46fb-84e9-7fde0bc34b8c/base/e593cb09-1392-46fb-84e9-7fde0bc34b8c.jpg
    const posterKey = posterUrl.split('/images/')[1]; // e593cb09-1392-46fb-84e9-7fde0bc34b8c/base/e593cb09-1392-46fb-84e9-7fde0bc34b8c.jpg
    return `${cdn}/images/${posterKey}`;
  }

  if (asset.type === 'document') {
    const key = version.data['images'][page].key;
    return `${cdn}/assets/${key}`;
  }

  return `${cdn}/assets/${version.original_key.split('-original')[0]}-base.jpg`;
};
